/**
 * Grupowanie osi dopasowan wedlug DNIA UTC (pierwsze 10 znakow daty ISO z pola od.data).
 */
(function () {
    'use strict';

    var ns = globalThis.PewniakiStatV2 = globalThis.PewniakiStatV2 || {};

    function dzienUTC(dopasowanie) {
        if (!dopasowanie || typeof dopasowanie !== 'object') {
            return null;
        }
        var od = dopasowanie.od;
        if (!od || typeof od !== 'object' || typeof od.data !== 'string') {
            return null;
        }
        // Daty sa pelnymi znacznikami ISO UTC, wiec dzien to ich staly prefiks.
        var dzien = od.data.slice(0, 10);
        return dzien.length === 10 ? dzien : null;
    }

    ns.os = function (input) {
        var wejscie = input && Array.isArray(input.dopasowania) ? input.dopasowania : [];
        var kubelki = Object.create(null);
        var dni = [];

        for (var i = 0; i < wejscie.length; i++) {
            var dzien = dzienUTC(wejscie[i]);
            if (dzien === null) {
                continue;
            }
            if (!kubelki[dzien]) {
                kubelki[dzien] = [];
                dni.push(dzien);
            }
            kubelki[dzien].push(wejscie[i]);
        }

        dni.sort();

        var grupy = [];
        for (var j = 0; j < dni.length; j++) {
            grupy.push({
                dzien: dni[j],
                count: kubelki[dni[j]].length,
                dopasowania: kubelki[dni[j]]
            });
        }

        return { liczba: wejscie.length, grupy: grupy };
    };
}());
